import { useMyMonitoringGetControlListWithState } from '@apps-common/apis/my-monitoring/control'
import { useGetUnitControlListWithState } from '@apps-common/apis/portal/control'
import { ButtonRoundSm } from '@apps-common/components/elements'
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalHeaderContainer } from '@apps-common/components/modals/modal'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'
import { ControlContextBridge, IControlContext } from '@apps-common/contexts/ControlContext'
import { useProjectHook } from '@apps-common/hooks/useProjectHook'
import { IUnitControlWithStateModel } from '@apps-common/types/portal/unit-control'
import { useMemo } from 'react'
import { Control } from './Control'
import { ControlPlaceHolder } from './ControlPlaceHolder'

interface IPortalUnitDetailsModalProps {
  status: string
  isActivated: boolean
  unitId: string
  // controls: IUnitControlWithStateModel[]
  // onControlStateUpdated: any
  layoutPrefix: string
  hideCreate?: boolean
  controlsContext?: IControlContext
  showDefaultControlOptions?: boolean
  // navigation?: IAppNavigation
}

export const ControlsModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IPortalUnitDetailsModalProps
}) => {
  const { status, isActivated, unitId, layoutPrefix, hideCreate, controlsContext, showDefaultControlOptions } = componentProps || {}

  const useGetControls = useProjectHook(useGetUnitControlListWithState, useMyMonitoringGetControlListWithState)

  const { data, onControlStateUpdated } = useGetControls({
    config: { enabled: !!unitId },
    unitId: unitId || ''
  })

  const remainderToNextMultipleOf3 = (length?: number) => {
    if (!length) return 0

    return (3 - (length % 3)) % 3
  }

  const remainder = useMemo(() => remainderToNextMultipleOf3(data?.length), [data])

  const content = (
    <ModalContainer innerClasses='!h-auto !min-h-0 !max-w-[400px] !bg-bg' onDismiss={onDismiss}>
      <ModalHeaderContainer classes='!bg-transparent !backdrop-blur-none'>
        <div className='flex items-start justify-between px-1'>
          <ModalHeader title='Controls' />
          <div className='flex items-center justify-end gap-[10px]'>
            {!hideCreate && (
              <ButtonRoundSm
                type='button'
                className='action-success'
                callback={() => onDismiss(JSON.stringify({ action: 'create' }), ModalDismiss.Confirm)}
              >
                <commonIcons.add />
              </ButtonRoundSm>
            )}
            <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
          </div>
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[70px] !pb-[50px] sm:!pb-[25px]'>
        <div className='grid grid-cols-3 sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-3 gap-[8px]'>
          {data &&
            data.map((c: IUnitControlWithStateModel, i: number) => {
              return (
                <div key={`modal-control-${i}-${c.unitControlId}`} className='flex'>
                  <Control
                    unitStatus={status}
                    // navigation={navigation}
                    isActivated={isActivated}
                    control={c}
                    onStateUpdatedCallback={onControlStateUpdated}
                    idPrefix={layoutPrefix}
                    showDefaultControlOptions={showDefaultControlOptions}
                  />
                </div>
              )
            })}
          {Array.from(Array(remainder)).map((_, i) => (
            <ControlPlaceHolder key={`modal-control-placeholder-${i}`} />
          ))}
        </div>
      </ModalBody>
    </ModalContainer>
  )

  if (!controlsContext) {
    return content
  }

  return <ControlContextBridge value={controlsContext}>{content}</ControlContextBridge>
}
